<template>
  <div id="vmain" style="padding: 0 1em;">
    <el-container
      v-loading.fullscreen.lock="$store.getters.getLoading"
      element-loading-text="資料载入中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-header v-bind:style="{'display': headerDisplay}" style="height:14rem; ">
        <vHeader ref="herader" :pageInfo=pageInfo @toggle="toggle" @getDefaultMenu="getDefaultMenu"/>
      </el-header>
      <el-main style="padding:0;">
        <component v-bind:is="currentComponent" class="container" @getDefaultMenu="getDefaultMenu" ></component>
      </el-main>
      <el-footer>
        <vFooter/>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Vue from 'vue'
import vFooter from '@/components/FooterView.vue'
import vHeader from '@/components/HeaderView.vue'
import vTitle from '@/components/TitlePage.vue'
export default {
  name: 'vmain',
  props: ['init'],
  components: {
    vFooter,
    vHeader,
    vTitle
  },
  data () {
    return {
      pageInfo: null,
      currentComponent: '',
      pageTitle: '',
      jsData: [],
      isIE: false
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    headerDisplay () {
      return (this.isIE? 'ruby': 'contents');
    }
  },
  methods: {
    toggle: function (appId, pageId) {
      //console.log('toggle call' + appId, pageId)
      if (appId==-2 && pageId==-2) {
        this.$store.dispatch('actionAppId', -2)
        this.$store.dispatch('actionPageId', -2)
        this.setCurComp('Help');
      } else {          
        this.$store.dispatch('actionAppId', appId)
        this.$store.dispatch('actionPageId', pageId)
        this.setCurComp(this.pageInfo[appId].subMenu[pageId].path);
      }
      this.setPageTitle();
      // this.$store.dispatch('actionAppId', appId)
      // this.$store.dispatch('actionPageId', pageId)
      // this.$emit('setCurComp', this.pageInfo[appId].subMenu[pageId].path)
      // this.pageTitle();
    },
    setPageTitle: function() {
      let url = ''
      if ((this.$store.getters.getAppId == -2) && (this.$store.getters.getPageId == -2)) {
        url = '連絡我們'
      } else if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId 
        url = this.pageInfo[appId].subMenu[pageId].title
      }
      console.log('======url===== :' + url)
      this.$store.dispatch('setSysTitle', url)
    },
    contactUs: function() {
      console.log('======contactUs=====')
      //this.currentComponent = 'Help'
    },
    setCurComp (evtValue) {
      // this.currentComponent = evtValue
      if (evtValue !== null) {
        //this.currentComponent = this.pageInfo[0].subMenu[this.$store.getters.getAppId].subMenu[this.$store.getters.getPageId].path
        this.currentComponent = evtValue
      } else {
        this.currentComponent = 'Help'
      }
      //console.log('MainView: setCurComp=' + this.currentComponent)
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    setComponent: function () {
      var len = this.pageInfo[0].subMenu.length
      var vm = this
      const requireComponent = require.context('.', false, /\.vue$/)
      requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName)
        // 因為得到的filename格式是: './baseButton.vue', 所以這裡我們去掉頭和尾，只保留真正的檔案名
        const componentName = vm.capitalizeFirstLetter(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
        var index = vm.jsData.indexOf(componentName);

        if (0 > index) {
          if (componentName === 'HelpView') {
            //console.log('setComponent:Help')
            Vue.component('Help', componentConfig.default || componentConfig)
            vm.jsData.push(componentName);
          } else {        
            var found = false
            for (var i = 0; i < len && !found; i++) {
              if (vm.pageInfo[0].subMenu[i].jsPath === componentName) {
                //console.log('MainView: componentName=' + componentName + '    path:' + vm.pageInfo[0].subMenu[i].path)
                Vue.component(vm.pageInfo[0].subMenu[i].path, componentConfig.default || componentConfig)
                vm.jsData.push(componentName);
                found = true
              }
            }    
          }
        }
      })
    },
    getDefaultMenu: function (sId, flag) {
      var vm = this
      if (!flag || (this.pageInfo == null)) {
        this.$http
          .get('./WebApi/Common/GetMenuItemBySort/'.concat(sId).concat('/').concat(this.$store.state.user.status))
          .then(function (response) {
            let appId = 0, pageId = 0, sort = -1;
            let cFlag = false;
            vm.pageInfo = response.data;
            vm.setComponent();
            
            for (let i = 0; i < vm.pageInfo.length; i++) {
              if (null != vm.pageInfo[i].subMenu) {
                for (var j = 0; j < vm.pageInfo[i].subMenu.length; j++) {
                  if (sort < vm.pageInfo[i].subMenu[j].sort) {
                    appId = i;
                    pageId = j;
                    sort = vm.pageInfo[i].subMenu[j].sort;
                    cFlag = true;
                  }
                }
              }
            }
            if (cFlag) {
              //vm.setCurComp(vm.pageInfo[appId].subMenu[pageId].path);
              vm.toggle(appId, pageId);
            }
          })
      }
    }
  },
  created () {
    console.log('======created MainView====='+this.sysId)
    var userAgent = navigator.vendor; 
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1; 
    if (this.sysId > 0) {
        this.getDefaultMenu( this.sysId, true);
    }
    // var vm = this
    // this.$http
    //   .get('./WebApi/Common/GetMenuItem/'.concat(this.sysId).concat('/').concat(this.$store.state.user.status))
    //   .then(function (response) {
    //     vm.pageInfo = response.data
    //     console.log('======created setComponent=====')
    //     vm.setComponent()
    //   }) 
  },
  watch: {
    sysId (newId, oldId) {
      console.log('======watch sysId====='+newId)
      this.getDefaultMenu(newId, true);
    },
    init(val, oldVal) {
      console.log('======watch init====='+val)
      this.getDefaultMenu(this.sysId, false);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  text-align: right;
  font-size: 12px;
  background: transparent;
  padding: 0.5em 1.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/MainView.vue